import { moduloBootstrap, paramUrlApp } from '../../utils/urlParamsApp';

export type AbaPrincipal =
  | 'projeto'
  | 'catalogo'
  | 'historico'
  | 'relatorio'
  | 'sobra'
  | 'produtoPorPalete'
  | 'tempoCorte'
  | 'analiseTempo'
  | 'tempoProducaoPeca'
  | 'adiantamentoMdf'
  | 'lotes'
  | 'boletimPontuacao'
  | 'boletimCalculadora'
  | 'boletimLinhaFabrica'
  | 'boletimTabelaDias'
  | 'boletimResumoDias'
  | 'boletimGrafico'
  | 'tempoEmbalar'
  | 'resultadosCopa'
  | 'instrucoes';

export const ABA_LABELS: Record<AbaPrincipal, string> = {
  projeto: 'Projeto',
  catalogo: 'Catálogo',
  historico: 'Histórico',
  relatorio: 'Relatório',
  sobra: 'Sobra',
  produtoPorPalete: 'Produto por Palete',
  tempoCorte: 'Tempo de Corte Exato por Pontuação',
  analiseTempo: 'Análise de Tempo',
  tempoProducaoPeca: 'Tempo de Corte por Peça em Produção',
  adiantamentoMdf: 'Adiantamento de MDF',
  lotes: 'Lotes',
  boletimPontuacao: 'Boletim Pontuação',
  boletimCalculadora: 'Boletim Calculadora',
  boletimLinhaFabrica: 'Linha de Pintura',
  boletimTabelaDias: 'Boletim Tabela Dias',
  boletimResumoDias: 'Boletim Resumo Dias',
  boletimGrafico: 'Boletim Gráfico',
  tempoEmbalar: 'Tempo de Embalagem',
  resultadosCopa: 'Resultados da Copa',
  instrucoes: 'Instruções',
};

const ABAS_VALIDAS = new Set<string>(Object.keys(ABA_LABELS));

export function isAbaPrincipal(v: string | null | undefined): v is AbaPrincipal {
  return typeof v === 'string' && ABAS_VALIDAS.has(v);
}

export function moduloFixoDaUrl(): AbaPrincipal | null {
  const modulo = moduloBootstrap() ?? paramUrlApp('modulo');
  return isAbaPrincipal(modulo) ? modulo : null;
}
